import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Modal } from 'web-ui-components/lib/organisms/modals';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { Container } from 'web-ui-components/lib/global/layout';
import { TextStyled } from 'web-ui-components/lib/atoms/text';
import withContent from '../../../containers/withContent';
import content, { contentPropTypes } from './CancelSuccessModal.content';
import {
	MANDATE_TYPE_SCHEDULE_PAYMENT,
	MANDATE_TYPE_BACS_CREDIT,
	MANDATE_TYPE_BACS_DEBIT,
	MANDATE_TYPE_DIRECT_DEBIT,
	MANDATE_TYPE_STANDING_ORDER,
	MANDATE_TYPE_SCHEDULE_TRANSFER,
	MANDATE_TYPE_IFT,
	MANDATE_TYPE_CHAPS,
} from '../../../config';

export const getCancelSuccessHeader = (
	mandateType,
	{
		cancelledSchedulePaymentSuccessHeader,
		cancelledBacsSuccessHeader,
		cancelledDDSuccessHeader,
		cancelledSOSuccessHeader,
		cancelledIftSuccessHeader,
		cancelledCHAPSSuccessHeader,
	}
) => {
	const foooterMsgs = {
		[MANDATE_TYPE_DIRECT_DEBIT]: cancelledDDSuccessHeader,
		[MANDATE_TYPE_STANDING_ORDER]: cancelledSOSuccessHeader,
		[MANDATE_TYPE_SCHEDULE_PAYMENT]: cancelledSchedulePaymentSuccessHeader,
		[MANDATE_TYPE_SCHEDULE_TRANSFER]: cancelledSchedulePaymentSuccessHeader,
		[MANDATE_TYPE_BACS_CREDIT]: cancelledBacsSuccessHeader,
		[MANDATE_TYPE_BACS_DEBIT]: cancelledBacsSuccessHeader,
		[MANDATE_TYPE_IFT]: cancelledIftSuccessHeader,
		[MANDATE_TYPE_CHAPS]: cancelledCHAPSSuccessHeader,
	};
	return get(foooterMsgs, mandateType, '');
};

export const getCancelSuccessBody = (
	mandateType,
	{ cancelledSuccessBody, cancelledIftSuccessBody, cancelledCHAPSSuccessBody }
) =>
	({
		[MANDATE_TYPE_IFT]: cancelledIftSuccessBody,
		[MANDATE_TYPE_CHAPS]: cancelledCHAPSSuccessBody,
	}[mandateType] || cancelledSuccessBody);

export const CancelSuccessModal = ({ content, handleClickOk, mandate: { mandateType } }) => {
	const { cancelledOkButton } = content;
	const cancelSuccessHeader = getCancelSuccessHeader(mandateType, content);
	const cancelSuccessBody = getCancelSuccessBody(mandateType, content);
	return (
		<Modal isOpen shouldCloseOnOverlayClick={false}>
			<Container className="modal__container u-padding-y-4 u-text-align-center">
				<Icon iconType="TickOutlineCircleLarge" size="lg" className="u-margin-x-auto u-margin-bottom-2" />
				<h3>{cancelSuccessHeader}</h3>
				<TextStyled size="bute">{cancelSuccessBody}</TextStyled>
				<Button
					className="u-margin-top-2"
					id="cancel-success-ok"
					onClick={handleClickOk}
					width="flush"
					display="primary"
				>
					{cancelledOkButton}
				</Button>
			</Container>
		</Modal>
	);
};

CancelSuccessModal.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	mandate: PropTypes.shape({
		mandateType: PropTypes.string.isRequired,
	}),
	handleClickOk: PropTypes.func.isRequired,
};
export default withContent({ content })(CancelSuccessModal);
